import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { changeTourStatus } from "../../api/tourStatusApi";
// import { changeTourStatus } from "../../api/toursStatusApi";

// Thunk for changing tour status
export const changeTourStatusThunk = createAsyncThunk(
  "toursStatus/changeTourStatus",
  async ({ status, tourId }, { rejectWithValue }) => {
    try {
      const response = await changeTourStatus({ status, tourId });
      return response.data; // Assuming the API response contains `data`
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Something went wrong, please try again"
      );
    }
  }
);

// Initial state
const initialState = {
  loading: false,
  success: false,
  error: null,
};

// Slice
const toursStatusSlice = createSlice({
  name: "toursStatus",
  initialState,
  reducers: {
    resetStatus(state) {
      state.loading = false;
      state.success = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(changeTourStatusThunk.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(changeTourStatusThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.error = null;
      })
      .addCase(changeTourStatusThunk.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload || "Failed to change tour status";
      });
  },
});

export const { resetStatus } = toursStatusSlice.actions;
export default toursStatusSlice.reducer;
